import { render, staticRenderFns } from "./XcBanner.vue?vue&type=template&id=28e6ccac&scoped=true&"
import script from "./XcBanner.vue?vue&type=script&lang=js&"
export * from "./XcBanner.vue?vue&type=script&lang=js&"
import style0 from "./XcBanner.vue?vue&type=style&index=0&id=28e6ccac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6ccac",
  null
  
)

export default component.exports